/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }], react/no-unused-prop-types: 0 */
/* global globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import DisplayMemberInfo from '../../components/member/DisplayMemberInfo';

class MemberInfoContainer extends Component {
  state = {
    memberId: '',
    member: null,
  };

  fetchMember = this.fetchMember.bind(this);

  componentDidMount() {
    this.fetchMember();
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchMember(nextProps.memberId);
  }

  fetchMember(id) {
    let memberId = '';
    if (id) {
      memberId = id;
    } else {
      ({ memberId } = this.props);
    }
    if (memberId < 1) {
      return;
    }
    const options = {
      credentials: 'same-origin',
    };
    console.log(memberId);
    fetch(`${get(globals, 'apiWebroot', '/')}member/get/${memberId}`, options)
      .then((resp) => resp.json())
      .then((data) => {
        if (get(data, '_id', null)) {
          this.setState({
            memberId,
            member: data,
          });
        }
      })
      .catch((error) => {
        this.setState({
          memberId,
          member: null,
        });
        console.log('fetch failed: ', error);
      });
  }

  render() {
    const { memberId, member } = this.state;

    let result;
    if (memberId.length > 0 && member && memberId === member._id) {
      result = <DisplayMemberInfo member={member} />;
    } else if (memberId.length > 0) {
      result = <p>{`Member ${memberId} not found`}</p>;
    }

    return <div>{result}</div>;
  }
}

MemberInfoContainer.propTypes = {
  memberId: PropTypes.string.isRequired,
};

export default MemberInfoContainer;
